module.exports = "<div ncy-breadcrumb></div> <contract-detail-info contract=vm.contract></contract-detail-info>";


//////////////////
// WEBPACK FOOTER
// ./features/account/contract-detail.html
// module id = 518
// module chunks = 0